<div>
  <div>
    <h4 class="mt-1 float-left" *ngIf="isOpenInfo">Campaign Information</h4>

    <div class="wrap_body campaign_dashboard">
      <div class="clearfix"></div>
      <div class="mb-3 row" *ngIf="!isOpenInfo">
        <div class="col-lg-12 mt-4">
          <div class="table_base">
            <app-progress-indicator
              *ngIf="campaignState.isLoadingAgentMarketingCampaignList$ | async"
              text="Please wait while we load"
            ></app-progress-indicator>
            <div class="table-responsive table_wrap">
              <table
                *ngIf="appState.appCompanyAliasValue == 'valuetest'"
                mat-table
                [dataSource]="tableDataSource"
                class="mat-elevation-z2 w-100"
              >
                <ng-container matColumnDef="campaignName">
                  <th mat-header-cell *matHeaderCellDef>Created Date</th>
                  <td mat-cell *matCellDef="let element">
                    <span class="truncated mt-0"> {{ element._id.date | simpleDate }}</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="campaignType">
                  <th mat-header-cell *matHeaderCellDef>Type</th>
                  <td mat-cell *matCellDef="let element">
                    <span class="truncated mt-0">
                      {{
                        element._id.messageId == 'PROSPEKTR_VALUETEST_NEW_LISTING_CAMPAIGN'
                          ? 'New Listing'
                          : 'Pending Listing'
                      }}
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="candidateCount">
                  <th mat-header-cell *matHeaderCellDef class="align-center">Total Targets</th>
                  <td mat-cell *matCellDef="let element" class="align-center">
                    {{ element.records.length }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="emailOpenRate">
                  <th mat-header-cell *matHeaderCellDef class="align-center">Open Rate</th>
                  <td mat-cell *matCellDef="let element" class="align-center">
                    {{
                      element.records.length > 0
                        ? ((element.totalReadCount / element.records.length) * 100).toFixed(0) + '%'
                        : '0%'
                    }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="updatedDate">
                  <th mat-header-cell *matHeaderCellDef>Recent Activity</th>
                  <td mat-cell *matCellDef="let element">{{ element.updatedDate | simpleDate }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="tableColumnList; sticky: true"></tr>
                <tr
                  mat-row
                  (click)="row.status != 'idle' ? openInfo(row) : null; changeBoolean(true)"
                  *matRowDef="let row; columns: tableColumnList"
                ></tr>

                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" [attr.colspan]="tableColumnList.length">
                    <div class="notFound text-center noData">
                      <div>
                        <img class="img-fluid" width="60" src="assets/images/notFound.svg" />
                        <h4>No campaigns found</h4>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>

              <div class="table-responsive table_wrap" *ngIf="appState.appCompanyAliasValue != 'valuetest'">
                <table mat-table [dataSource]="tableDataSource" class="mat-elevation-z2 w-100">
                  <ng-container matColumnDef="campaignName">
                    <th mat-header-cell *matHeaderCellDef>Campaign Name</th>
                    <td mat-cell *matCellDef="let element">
                      <span class="truncated mt-0">
                        {{ DEFAULT_AUTOMATED_CAMP[element?._id] || element?._id }}
                      </span>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="candidateCount">
                    <th mat-header-cell *matHeaderCellDef class="align-center">Total Targets</th>
                    <td mat-cell *matCellDef="let element" class="align-center">
                      {{ element?.data[0]?.candidateTotalCount || element?.data?.length }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="LeadCaptureRate">
                    <th mat-header-cell *matHeaderCellDef class="align-center">Lead Capture Rate</th>
                    <td mat-cell *matCellDef="let element" class="align-center">
                      {{
                        getLeadCaptureRate(
                          element,
                          isAgent ? 'agent' : isCompanyManager ? 'companyManager' : isLoanOfficer ? 'loanOfficer' : null
                        ) | number: '1.0-0'
                      }}%
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="emailOpenRate">
                    <th mat-header-cell *matHeaderCellDef class="align-center">Open Rate</th>
                    <td mat-cell *matCellDef="let element" class="align-center">
                      {{
                        (
                          ((element.data[0]?.totalReadCount ?? element.totalReadCount ?? 0) /
                            ((element.data[0]?.totalSendCount ?? element.data.length) || 1)) *
                          100
                        ).toFixed(0) + '%'
                      }}
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="tableDefaultMarketingColumnList; sticky: true"></tr>
                  <tr
                    mat-row
                    (click)="row.status != 'idle' ? openInfo(row) : null; changeBoolean(true)"
                    *matRowDef="let row; columns: tableDefaultMarketingColumnList"
                  ></tr>
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" [attr.colspan]="tableColumnList.length">
                      <div class="notFound text-center noData">
                        <div>
                          <img class="img-fluid" width="60" src="assets/images/notFound.svg" />
                          <h4>No campaigns found</h4>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <mat-paginator
              [pageSizeOptions]="[10, 20]"
              showFirstLastButtons
              class="d-inline-block m-wdh w-100"
              [length]="totalCount"
              [pageIndex]="pageIndex"
              (page)="pageChange($event)"
            >
            </mat-paginator>
          </div>
        </div>
      </div>
      <app-agent-marketing-campaign-info
        *ngIf="isOpenInfo"
        (isOpenInfoEvent)="onBack($event)"
        [selectedInfo]="selectedInfo"
      ></app-agent-marketing-campaign-info>
    </div>
  </div>
</div>
